export default __webpack_public_path__ + "static/media/help.39b07ed6.svg";